(() => {
  'use strict';
  const root = document.querySelector('[data-am-holiday-audio]');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const invite = root.querySelector('[data-audio-invite]');
  const toggle = root.querySelector('[data-audio-toggle]');
  const label = root.querySelector('[data-audio-label]');
  const status = root.querySelector('[data-audio-status]');
  const key = 'amelie-holiday-ambience-v2';
  const duration = 64 * 60 / 110;
  const arrangement = 'holiday-classic-option1-v1';
  root.dataset.audioBpm = '110';
  root.dataset.audioArrangement = arrangement;
  root.dataset.audioMode = 'autoplay-when-allowed';
  let choice = 'auto';
  let position = 0;
  let media = null;
  let pending = false;
  let attempt = 0;
  let automaticBlocked = false;
  try {
    const saved = JSON.parse(sessionStorage.getItem(key) || 'null');
    if (saved && Date.now() - saved.updatedAt < 30 * 60 * 1000 && ['auto', 'on', 'off'].includes(saved.choice)) {
      choice = saved.choice;
      position = saved.arrangement === arrangement && Number.isFinite(saved.position) ? Math.max(0, saved.position) % duration : 0;
    }
  } catch (_) {}
  const wantsAudio = () => choice === 'on' || choice === 'auto';
  const save = () => {
    if (media && media.readyState >= 1 && Number.isFinite(media.currentTime)) position = media.currentTime;
    try { sessionStorage.setItem(key, JSON.stringify({ choice, position, arrangement, updatedAt: Date.now() })); } catch (_) {}
  };
  const show = state => {
    root.hidden = false;
    root.dataset.audioState = state;
    invite.hidden = state !== 'prompt';
    toggle.hidden = state === 'prompt' || state === 'unsupported';
    const playing = state === 'playing';
    const canStop = playing || state === 'loading';
    toggle.setAttribute('aria-pressed', String(canStop));
    toggle.setAttribute('aria-label', canStop ? root.dataset.labelMute : root.dataset.labelEnable);
    label.textContent = root.dataset['label' + state.charAt(0).toUpperCase() + state.slice(1)] || root.dataset.labelMuted;
    status.textContent = state === 'prompt' ? '' : label.textContent;
  };
  const offerActivation = () => {
    if (!wantsAudio() || document.hidden) return;
    if (choice === 'auto') automaticBlocked = true;
    show(choice === 'auto' ? 'prompt' : 'awaiting');
  };
  const stop = () => {
    save();
    attempt++;
    pending = false;
    if (media) media.pause();
  };
  const play = () => {
    if (!wantsAudio() || document.hidden || pending || choice === 'auto' && automaticBlocked) return;
    if (!root.dataset.audioSrc || typeof window.Audio !== 'function') { show('unsupported'); return; }
    if (media && !media.paused) { show('playing'); return; }
    if (choice === 'auto' && typeof window.navigator?.getAutoplayPolicy === 'function') {
      try {
        const policy = window.navigator.getAutoplayPolicy('mediaelement');
        if (policy === 'disallowed' || policy === 'allowed-muted') { offerActivation(); return; }
      } catch (_) {}
    }
    try {
      if (!media) {
        media = document.createElement('audio');
        media.hidden = true;
        media.preload = 'none';
        media.loop = true;
        media.volume = .65;
        media.setAttribute('playsinline', '');
        media.setAttribute('aria-hidden', 'true');
        media.addEventListener('loadedmetadata', () => {
          if (Number.isFinite(media.duration) && media.duration > 0) {
            try { media.currentTime = position % media.duration; } catch (_) {}
          }
        });
        media.addEventListener('playing', () => {
          pending = false;
          if (wantsAudio() && !document.hidden) { save(); show('playing'); }
          else media.pause();
        });
        media.addEventListener('error', () => {
          pending = false;
          offerActivation();
        });
        media.addEventListener('pause', () => {
          if (wantsAudio() && !document.hidden && !pending) show('awaiting');
        });
        media.src = root.dataset.audioSrc;
        root.appendChild(media);
      } else if (media.error) {
        media.load();
      }
      const request = ++attempt;
      pending = true;
      show('loading');
      const started = media.play();
      if (started && typeof started.then === 'function') {
        started.then(() => {
          if (request !== attempt) {
            if (!wantsAudio() || document.hidden) media.pause();
            return;
          }
          pending = false;
          if (wantsAudio() && !document.hidden && !media.paused) { save(); show('playing'); }
        }).catch(() => {
          if (request !== attempt) return;
          pending = false;
          offerActivation();
        });
      }
    } catch (_) {
      pending = false;
      offerActivation();
    }
  };
  root.addEventListener('click', event => {
    if (event.target.closest('[data-audio-skip]')) {
      choice = 'off'; stop(); show('muted'); toggle.focus({ preventScroll: true });
    } else if (event.target.closest('[data-audio-activate]')) {
      choice = 'on'; automaticBlocked = false; save(); play(); toggle.focus({ preventScroll: true });
    } else if (event.target.closest('[data-audio-toggle]')) {
      if (wantsAudio() && media && (!media.paused || pending)) { choice = 'off'; stop(); show('muted'); }
      else { choice = 'on'; automaticBlocked = false; save(); play(); }
    }
  });
  const resumeAfterActivation = event => {
    if (event.target.closest('[data-am-holiday-audio]')) return;
    if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) return;
    if (choice === 'on' && (!media || media.paused)) play();
  };
  document.addEventListener('click', resumeAfterActivation);
  document.addEventListener('keydown', resumeAfterActivation);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) { stop(); if (wantsAudio() && !automaticBlocked) show('paused'); }
    else if (wantsAudio()) play();
  });
  window.addEventListener('pagehide', stop);
  window.addEventListener('pageshow', event => { if (event.persisted && wantsAudio()) play(); });
  if (typeof window.Audio !== 'function' || !root.dataset.audioSrc) root.hidden = true;
  else if (choice === 'off') show('muted');
  else play();
})();
